import type { Camp, InputVector } from '@orbomb/sim';

function quantizeAxis(value: number): number {
  if (!Number.isFinite(value)) return 0;
  const clamped = Math.max(-1, Math.min(1, value));
  const quantized = Math.round(clamped * 1000) / 1000;
  return quantized === 0 ? 0 : quantized;
}

function quantizeInput(input: InputVector): InputVector {
  return { x: quantizeAxis(input.x), y: quantizeAxis(input.y) };
}

/**
 * Screen input uses the same axes as the local keyboard (up is negative Y).
 * ORANGE faces the opposite way on the arena, so their stick is flipped into
 * simulation space. The simulation itself is never rotated.
 */
export function simInputForCamp(screen: InputVector, camp: Camp): InputVector {
  const quantized = quantizeInput(screen);
  if (camp === 'TURQUOISE') return quantized;
  return {
    x: quantized.x === 0 ? 0 : -quantized.x,
    y: quantized.y === 0 ? 0 : -quantized.y,
  };
}
